export default class {
    constructor ($state, lodash, MomentService, REVIEW_STATUS_ENUM) {
        this.$state = $state;
        this.lodash = lodash;
        this.MomentService = MomentService;
        this.REVIEW_STATUS_ENUM = REVIEW_STATUS_ENUM;
    }

    /**
     * This function should be called after review is loaded from server
     * Makes shortcuts to some widely used variables
     * @param review
     * @param isManagerView
     */
    loadAdditionalData (review, isManagerView = false) {
        // review.guid should always be guid of the person viewing
        review.guid = this.$state.params.guid;

        // in case of coursy admin set guid as manager guid
        if (isManagerView && !review.guid) {
            review.guid = review.managerGuid;
        }

        review.isManager = review.guid === review.managerGuid;
        review.preferredLanguage = review.isManager ? review.manager.coursyLanguage : review.user.coursyLanguage;
        review.companyLanguage = review.isManager ? review.manager.company.defaultLanguage : review.user.company.defaultLanguage;
        review.departments = review.userDrlsWithValue.map(drl => drl.departmentName).join(', ');
        review.roles = review.userDrlsWithValue.map(drl => drl.roleName).join(', ');

        review.isReadOnly = false;
        // we separate each if clause for easier readability
        if (review.status === this.REVIEW_STATUS_ENUM.KEYS.CONFIRMED) {
            review.isReadOnly = true;
        }
        else if (review.isManager && review.status !== this.REVIEW_STATUS_ENUM.KEYS.FILL_MANAGER) {
            review.isReadOnly = true;
        }
        else if (!review.isManager && this.MomentService.isPassedDate(review.deadline)) {
            review.isReadOnly = true;
        }
        else if (!review.isManager && review.status === this.REVIEW_STATUS_ENUM.KEYS.FILL_MANAGER) {
            review.isReadOnly = true;
        }
        else if (!review.isManager && review.status === this.REVIEW_STATUS_ENUM.KEYS.CONFIRM_EMPLOYEE) {
            review.isReadOnly = true;
        }
        else if (isManagerView) {
            review.isReadOnly = true;
        }
    }

    /**
     * This functions maps together review questionAnswers and questions that come from index api
     * Returns array of questions that are suited for sending to batch set-answers api
     * @param questionByCategory questions grouped by categories
     * @param review that should have questionAnswer property set
     */
    getQuestionAnswers (questionByCategory, review) {
        const mappedQuestions = {};
        this.lodash.forEach(questionByCategory, category => {
            this.lodash.forEach(category.questions, question => {
                mappedQuestions[question.activeI18n.questionId] = this.lodash.extend(
                    { questionId: question.activeI18n.questionId, reviewId: review.id },
                    this.lodash.find(review.questionAnswers, { questionId: question.activeI18n.questionId })
                );
            });
        });
        return mappedQuestions;
    }

    /**
     * Replacec review related question answers with "newAnswers" returnd by batch-set api
     * @param newAnswers
     * @param review
     */
    updateQuestionAnswers (newAnswers, review) {
        this.lodash.forEach(newAnswers, answer => {
            review.questionAnswers[answer.id] = answer;
        });
    }

    /**
     * Wrapper function to get all the needed expands to cover all required functionality
     */
    getExpandString () {
        return 'form,room,user.company,manager.company,userDrlsWithValue,questionAnswers,goals,results,trainingNeeds';
    }
}



// WEBPACK FOOTER //
// ./src/app/services/review/index.js